import axios from 'axios';
import {getDataEndpointUrl} from './data-url-helpers';
import {loadEntityActions} from './entityactions';

export function saveEntity(entityTypeIdOrName, entityId, data) {
    const endpoint = getDataEndpointUrl(entityTypeIdOrName);
    return axios.post(`${endpoint}/${entityId}`, data);
}

export function patchEntity(entityTypeIdOrName, entityId, data) {
    const endpoint = getDataEndpointUrl(entityTypeIdOrName);
    return axios.patch(`${endpoint}/${entityId}`, data);
}

export function createEntity(entityTypeIdOrName, data) {
    const endpoint = getDataEndpointUrl(entityTypeIdOrName);
    return axios.post(endpoint, data);
}

export function deleteEntity(entityTypeIdOrName, entityId) {
    const endpoint = getDataEndpointUrl(entityTypeIdOrName);
    return axios.delete(`${endpoint}/${entityId}`);
}

export async function performEntityAction(entityTypeIdOrName, entityId, actionId, data) {
    const endpoint = getDataEndpointUrl(entityTypeIdOrName);
    return await axios.post(`${endpoint}/${entityId}/actions/${actionId}`, data);
}

export async function performBulkEntityAction(entityTypeIdOrName, actionId, data, filter) {
    const endpoint = getDataEndpointUrl(entityTypeIdOrName);
    return await axios.post(`${endpoint}/actions/${actionId}`, data, {params: {filter}});
}

export async function runButtonAutomationSingle(entityTypeIdOrName, buttonAutomationId, entityId) {
    const endpoint = getDataEndpointUrl(entityTypeIdOrName);
    return await axios.post(`${endpoint}/${entityId}/button-automations/${buttonAutomationId}`);
}

export async function runButtonAutomationBulk(entityTypeIdOrName, buttonAutomationId, filter) {
    const endpoint = getDataEndpointUrl(entityTypeIdOrName);
    return await axios.post(`${endpoint}/button-automations/${buttonAutomationId}`, {params: {filter}});
}

/**
 * Navigate to the detail page or the edit page of an entity, depending on the permissions of the user and what formatters are available.
 *
 * This method actually modifies window.location.href, so you should not expect a return value.
 *
 * **Note:** Your editor may tell you that this method is unused, but it is not: it is exposed to plugins
 * @param entityTypeIdOrName
 * @param entityId
 * @returns {Promise<void>}
 */
export async function navigateToDetail(entityTypeIdOrName, entityId) {
    const {entityLink} = await loadEntityActions(entityTypeIdOrName, entityId);
    // Note: in order for the link to work with react router we need the # in front;
    // also @entityLink starts with a slash, ignore that it looks like its glued to the #
    window.location.href = `/#${entityLink}`;
}

export function getFileUploadUrl(fileName, parentTypeIdOrName) {
    const endpoint = getDataEndpointUrl(parentTypeIdOrName);
    return axios.get(`${endpoint}/file-upload-url`, {
        params: {
            fileName: fileName,
        },
    });
}

export function uploadToBlobStorage(uploadUrl, file, fileType) {
    return axios({
        method: 'put',
        url: uploadUrl,
        data: file,
        headers: {
            'Content-Type': fileType,
            'x-ms-blob-type': 'BlockBlob',
        },
        transformRequest: [
            (data, headers) => {
                // axios has a default "authorization" header, but we don't want to
                // send this data to Azure. So we need to delete the default header here.
                delete headers.Authorization;
                return data;
            },
        ],
    });
}

export async function checkBlobExists(url) {
    try {
        await axios({
            method: 'head',
            url: url,
            transformRequest: [
                (data, headers) => {
                    delete headers.Authorization;
                    return data;
                },
            ],
        });
        return true;
    } catch {
        return false;
    }
}
